import { formatNumber } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslationService } from '../services/translation.service';

@Pipe({
    name: 'localizedNumber',
    standalone: false
})
export class LocalizedNumberPipe implements PipeTransform {
    private readonly translationService = inject(TranslationService);

    transform(value?: any, format = '1.0-2'): string {
        // `!value` would also react to zeros.
        // eslint-disable-next-line no-null/no-null
        if (value == null) {
            return '';
        }

        return formatNumber(value, this.translationService.getCurrent().code, format);
    }
}
